/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OrganizationRole } from './';
import {
    OrganizationRoleFromJSON,
    OrganizationRoleFromJSONTyped,
    OrganizationRoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationRoleUpdateRequest
 */
export interface OrganizationRoleUpdateRequest {
    /**
     * 
     * @type {OrganizationRole}
     * @memberof OrganizationRoleUpdateRequest
     */
    role: OrganizationRole;
}

/**
 * Check if a given object implements the OrganizationRoleUpdateRequest interface.
 */
export function instanceOfOrganizationRoleUpdateRequest(value: object): value is OrganizationRoleUpdateRequest {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function OrganizationRoleUpdateRequestFromJSON(json: any): OrganizationRoleUpdateRequest {
    return OrganizationRoleUpdateRequestFromJSONTyped(json, false);
}

export function OrganizationRoleUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationRoleUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'role': OrganizationRoleFromJSON(json['role']),
    };
}

export function OrganizationRoleUpdateRequestToJSON(value?: OrganizationRoleUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'role': OrganizationRoleToJSON(value['role']),
    };
}

